import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
const purchases = [{
  name: 'Valentina R.',
  city: 'Buenos Aires',
  product: 'Megapack Anti Pantalla + Método Desconectado™',
  time: 'hace 2 min'
}, {
  name: 'Carolina M.',
  city: 'Córdoba',
  product: 'Megapack Anti Pantalla',
  time: 'hace 5 min'
}, {
  name: 'Luciana S.',
  city: 'Rosario',
  product: 'Megapack Anti Pantalla + Método Desconectado™',
  time: 'hace 8 min'
}, {
  name: 'Florencia T.',
  city: 'Mendoza',
  product: 'Megapack Anti Pantalla',
  time: 'hace 12 min'
}, {
  name: 'Romina G.',
  city: 'Tucumán',
  product: 'Megapack Anti Pantalla + Método Desconectado™',
  time: 'hace 15 min'
}, {
  name: 'Daniela F.',
  city: 'Santa Fe',
  product: 'Megapack Anti Pantalla + Método Desconectado™',
  time: 'hace 18 min'
}, {
  name: 'Jimena P.',
  city: 'La Plata',
  product: 'Megapack Anti Pantalla',
  time: 'hace 22 min'
}, {
  name: 'Natalia B.',
  city: 'Mar del Plata',
  product: 'Megapack Anti Pantalla + Método Desconectado™',
  time: 'hace 25 min'
}, {
  name: 'Silvina C.',
  city: 'Salta',
  product: 'Megapack Anti Pantalla',
  time: 'hace 30 min'
}, {
  name: 'Paola L.',
  city: 'Neuquén',
  product: 'Megapack Anti Pantalla + Método Desconectado™',
  time: 'hace 35 min'
}, {
  name: 'Verónica H.',
  city: 'San Juan',
  product: 'Megapack Anti Pantalla',
  time: 'hace 40 min'
}, {
  name: 'Mariana K.',
  city: 'Paraná',
  product: 'Megapack Anti Pantalla + Método Desconectado™',
  time: 'hace 45 min'
}];
export function PurchaseNotifications() {
  const [current, setCurrent] = useState<number | null>(null);
  const [visible, setVisible] = useState(false);
  useEffect(() => {
    let index = 0;
    const initialTimeout = setTimeout(() => {
      setCurrent(index);
      setVisible(true);
      setTimeout(() => setVisible(false), 4000);
      index = (index + 1) % purchases.length;
    }, 6000);
    const interval = setInterval(() => {
      setCurrent(index);
      setVisible(true);
      setTimeout(() => setVisible(false), 4000);
      index = (index + 1) % purchases.length;
    }, 12000 + Math.random() * 6000);
    return () => {
      clearTimeout(initialTimeout);
      clearInterval(interval);
    };
  }, []);
  const purchase = current !== null ? purchases[current] : null;
  return <div className="fixed bottom-4 left-4 z-50" style={{
    maxWidth: 'calc(100vw - 32px)'
  }} data-id="element-286">
      <AnimatePresence data-id="element-287">
        {visible && purchase && <motion.div initial={{
        opacity: 0,
        y: 40,
        scale: 0.95
      }} animate={{
        opacity: 1,
        y: 0,
        scale: 1
      }} exit={{
        opacity: 0,
        y: 20,
        scale: 0.95
      }} transition={{
        duration: 0.35,
        ease: 'easeOut'
      }} className="flex items-center gap-3 bg-white border border-orange-300 rounded-xl px-4 py-3 shadow-lg max-w-sm" style={{
        fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif'
      }} data-id="element-288">
            {/* AVATAR */}
            <div className="flex h-9 w-9 shrink-0 items-center justify-center bg-orange-100 text-orange-500 rounded-full text-sm font-black" data-id="element-289">
              👩
            </div>

            {/* INFO */}
            <div className="min-w-0 flex-1" data-id="element-290">
              <p className="text-xs font-bold text-gray-900 m-0 truncate" data-id="element-291">
                {purchase.name} de {purchase.city}
              </p>
              <p className="text-[10px] text-gray-600 m-0 truncate" data-id="element-292">
                acaba de comprar{' '}
                <span className="font-semibold text-orange-500" data-id="element-293">
                  {purchase.product}
                </span>
              </p>
              <p className="text-[9px] text-gray-400 m-0 mt-0.5" data-id="element-294">
                🕐 {purchase.time}
              </p>
            </div>

            {/* BADGE VERIFICADO */}
            <div className="shrink-0" data-id="element-295">
              <span className="text-[9px] font-bold text-green-600 bg-green-50 border border-green-200 rounded-full px-1.5 py-0.5" data-id="element-296">
                ✓ Verificado
              </span>
            </div>
          </motion.div>}
      </AnimatePresence>
    </div>;
}